// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"95e3642c","186":"5a8d3d17","215":"05633ea6","372":"430b6f99","377":"d460848b","630":"673b8cc0","738":"3fe42891","841":"a143f376","851":"e5c03394","856":"1a841f55"}[chunkId] + ".chunk.js";
};